import classNames from 'classnames/bind';
import styles from './Item.module.css';

interface Item {
  id: string;
  title?: string;
  classnames?: string[];
  innerClass?: string;
  children?: React.ReactNode;
}
export default function Item({
  id,
  title,
  classnames,
  innerClass,
  children,
}: Item) {
  const cx = classNames.bind(styles);

  return (
    <>
      <div className={cx('panel', id, [classnames])}>
        {title && (
          <div className={cx('panel_title')}>
            <span>{title}</span>
          </div>
        )}
        <div className={cx('panel_inner', innerClass)}>{children}</div>
      </div>
    </>
  );
}
